import Link from 'gatsby-link';
import React from 'react';
import styled from '@emotion/styled'
import { css } from '@emotion/core'
import PersonCardImageComponent from './personCardImage.component';

const PersonCardComponent = ({ name, title, image, slug, onVisible }) => (
    <Link to={`/person/${slug}`}>
        <PersonCardImageComponent image={image} />
        <div css={teaserDetailsWrapper}>
            <Name>{name}</Name>
            <Title>{title}</Title>
        </div>
    </Link>
);

const teaserDetailsWrapper = css`
    margin-top: 30px;
`;

const Title = styled.h4`
`;
const Name = styled.h3`
`;

export default PersonCardComponent;
